'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils$1 = require('@chakra-ui/utils');
var utils = require('./utils.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["columns", "spacing", "minChildWidth"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Editable
 *
 * The wrapper that provides context and logic for all editable
 * components. It renders a `div`
 *
 * @TODO: Functionality is not implemented; it is purely cosmetic at this point.
 */
var Editable = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('Editable', props);
  var _omitThemingProps = react.omitThemingProps(props),
    _omitThemingProps$col = _omitThemingProps.columns,
    columns = _omitThemingProps$col === void 0 ? 2 : _omitThemingProps$col,
    _omitThemingProps$spa = _omitThemingProps.spacing,
    spacing = _omitThemingProps$spa === void 0 ? '1em' : _omitThemingProps$spa,
    _omitThemingProps$min = _omitThemingProps.minChildWidth,
    minChildWidth = _omitThemingProps$min === void 0 ? null : _omitThemingProps$min,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var theme = react.useTheme();
  var templateColumns = minChildWidth ? utils.widthToColumns(minChildWidth, theme) : utils.countToColumns(columns);
  var editableStyles = _objectSpread({
    display: 'grid',
    columnGap: spacing,
    gridTemplateColumns: templateColumns
  }, styles.editable);
  return /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref,
    sx: editableStyles,
    className: utils$1.cx('chakra-editable', props.className)
  }, rest)));
});
Editable.displayName = 'Editable';
exports.Editable = Editable;